export default {"src":"/_next/static/media/27.b9b7d9ca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};